
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M935.91 480.46l-5.59-4.92L968 448.92l-58-99.69 76.88-162H107.63L0 556.44l103.63 19.46-1.31 5.92a190.24 190.24 0 00-4.43 40.94c0 104.79 85.25 190 190 190a190.14 190.14 0 00187.77-160.38l1-6.22 152.3 34.58 1.06 3.12a192.3 192.3 0 0066 91 188.42 188.42 0 00114 38c104.79 0 190-85.25 190-190a189.78 189.78 0 00-64.11-142.4zm-29-246.18l-40.55 92.06-10.49 23.44L900.82 427H636.31l-57.22 110.58-115.48-269.27-76.4 157.11H87.67l54.63-191.14zM810 765.72a143.52 143.52 0 01-137.59-104.2l-1.26-4.41a42.54 42.54 0 01-1.68-7.24c-.26-1.61-.65-4-1.38-8.16l-.51-2.79-33.13-4.92-9.22-1.75-151.71-34.76-46.59-8.75 1.14 5.69a144.91 144.91 0 012.8 28.33c0 3.71-.14 7.24-.41 11v.34c-5.87 73.81-68.46 131.62-142.55 131.62-78.82 0-143-64.14-143-143a141.85 141.85 0 0122.72-77.23l3.18-4.9-110.16-20.66 18.6-65.09h326.36l56.31-115.79L576.6 606.42l77.6-150h221.53l-30.05 21.23-6.83 4.84 8.1 2.16a141 141 0 0140.57 18.07 142.5 142.5 0 0165.4 120c0 78.86-64.12 143-142.92 143z"}})])
          )
        }
      }
    